import api from '@/lib/axios';
import type { Paginated, Staff } from '@/services/school.api';

function unwrap<T>(r: { data: { data?: T } | T }): T {
  const body: any = r.data;
  return (body?.data ?? body) as T;
}

export interface OrgSchoolOption {
  id: string;
  name: string;
}

export interface OrgStaffListParams {
  schoolId: string;
  page?: number;
  limit?: number;
  search?: string;
  status?: Staff['status'];
  department?: string;
}

export const OrgStaffApi = {
  schools: async (): Promise<OrgSchoolOption[]> => unwrap(await api.get('/org/staff/schools')),

  list: async (params: OrgStaffListParams): Promise<Paginated<Staff>> => unwrap(await api.get('/org/staff', { params })),

  create: async (data: Record<string, unknown> & { schoolId: string }): Promise<Staff> => unwrap(await api.post('/org/staff', data)),

  update: async (id: string, data: Record<string, unknown> & { schoolId: string }): Promise<Staff> =>
    unwrap(await api.patch(`/org/staff/${id}`, data)),

  remove: async (id: string, schoolId: string): Promise<{ deleted: true; id: string }> =>
    unwrap(await api.delete(`/org/staff/${id}`, { params: { schoolId } })),
};
